<template>
  <div>
    <a-modal width="1024px" title="广告预播点位" v-model="visibleModal" @cancel="close">
      <a-table
        :columns="columns"
        :dataSource="mediaList"
        class="update-table"
        :pagination="false"
        :scroll="{ x: 1550 }"
      >
        <template slot="publishStatus" slot-scope="publishStatus">
          <span v-if="publishStatus == '0'"
            ><a-badge status="warning" />不接广告</span
          >
          <span v-if="publishStatus == '1'"
            ><a-badge status="success" />可接广告</span
          >
        </template>
        <template slot="mediaStatus" slot-scope="mediaStatus">
          <span v-if="mediaStatus == 1"
            ><a-badge status="success" />设备在线</span
          >
          <span v-else-if="mediaStatus == 0"
            ><a-badge status="warning" />设备离线</span
          >
          <span v-else-if="mediaStatus == 2"
            ><a-badge status="warning" />离线超时</span
          >
        </template>
        <span
          slot="operate"
          slot-scope="row"
          style="color: #1890ff; cursor: default"
          @click="operate(row)"
        >
          预播列表
        </span>
      </a-table>
      <div class="page-wrap">
        <a-pagination
          :pageSizeOptions="pageSizeOptions"
          :total="total"
          showSizeChanger
          showQuickJumper
          :pageSize="pageSize"
          v-model="current"
          @showSizeChange="onShowSizeChange"
          @change="changePage"
        >
        </a-pagination>
      </div>
      <template slot="footer">
        <a-button @click="close">关闭</a-button>
      </template>
    </a-modal>
    <!--播放列表-->
    <a-modal title="播放列表" v-model="playListModal" width="50%">
      <a-table :columns="playColumns" :dataSource="playList">
        <template slot="planName" slot-scope="row">
          <a href="javascript:;" @click="goPlanDetail(row)">{{
            row.planName
          }}</a>
        </template>
        <template slot="action" slot-scope="row">
          <a href="javascript:;" @click="showMaterial(row)">查看物料</a>
        </template>
      </a-table>
      <template slot="footer">
        <a-button @click="playListModal = false">关闭</a-button>
      </template>
    </a-modal>
    <!--查看物料-->
    <a-modal v-model="materialModal" :footer="null" width="450px">
      <div class="material-box" v-if="materialInfo.playType == 2">
        <div
          v-for="(item, index) in materialInfo.materialDetailsList"
          :key="index"
          class="img-mask"
          :class="item.adSpace == 2 ? 'video-mask' : ''"
        >
          <img v-if="item.fileType == 1" :src="item.fileUrl" alt="" />
          <video
            v-if="item.fileType == 3"
            :src="item.fileUrl"
            autoplay="autoplay"
            loop="loop"
            controls
          ></video>
        </div>
      </div>
      <div class="material-box full-screen-mask" v-else>
        <div
          class="img-mask"
          v-if="materialInfo.materialDetailsList.length > 0"
        >
          <img
            v-if="materialInfo.materialDetailsList[0].fileType == 1"
            :src="materialInfo.materialDetailsList[0].fileUrl"
            alt=""
          />
          <video
            v-else
            :src="materialInfo.materialDetailsList[0].fileUrl"
            autoplay="autoplay"
            loop="loop"
            controls
          ></video>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import api from "../../../commomFun/api.js";
import timeFormat from "../../../commomFun/timeFormat";
export default {
  name: "PreBroadcast",
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    requestParams: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  watch: {
    visible(val) {
      this.visibleModal = val
      if (val) {
        this.getMediaList()
      }
    },
  },
  data() {
    return {
      visibleModal: false,
      columns: [
        {
          title: "省份-城市-区县",
          width: 140,
          ellipsis: true,
          customRender: (text, record, index)=>{return `${record.province||''}-${record.city||''}-${record.area||''}`}
        },
        {
          title: "所属网点",
          key: "communityName",
          dataIndex: "communityName",
          width: 140,
          ellipsis: true,
        },
        {
          title: "点位名称",
          key: "doorName",
          dataIndex: "doorName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "媒体型号",
          key: "deviceCode",
          dataIndex: "deviceCode",
          width: 140,
          ellipsis: true,
        },
        {
          title: "MAC",
          key: "MAC",
          dataIndex: "MAC",
          width: 120,
          ellipsis: true,
        },
        {
          title: "开放情况",
          key: "publishStatus",
          dataIndex: "publishStatus",
          width: 100,
          ellipsis: true,
          scopedSlots: {
            customRender: "publishStatus",
          }
        },
        {
          title: "网络情况",
          key: "mediaStatus",
          dataIndex: "mediaStatus",
          width: 100,
          ellipsis: true,
          scopedSlots: {
            customRender: "mediaStatus",
          }
        },
        {
          title: "操作",
          key: "operate",
          width: 90,
          scopedSlots: { customRender: "operate" },
        },
      ],
      mediaList: [],
      pageSizeOptions: ["10", "20", "30", "40"],
      current: 1,
      pageSize: 10,
      total: 0,
      //播放列表
      playListModal: false,
      playColumns: [
        {
          title: "计划名称",
          key: "planName",
          scopedSlots: { customRender: "planName" },
        },
        {
          title: "开始时间",
          dataIndex: "beginTime",
          key: "beginTime",
        },
        {
          title: "结束时间",
          dataIndex: "endTime",
          key: "endTime",
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      playList: [
        {
          key: "1",
          planName: "",
          beginTime: "",
          endTime: "",
        },
      ],
      //查看物料
      materialModal: false,
      materialInfo: {
        playType: 1,
        materialDetailsList: [
          {
            fileType: 1, //1-图片 3-视频
            fileUrl: "../../../public/images/a-1.png",
            playDuration: "", //上传物料视频时长
            playForm: "", //上传物料播放形式
          },
        ],
      },
    };
  },
  methods: {
    close() {
      this.$emit("close")
    },
    operate(row) {
      console.log("row", row);
      this.pointId = row.pointId
      this.playListModal = true;
      this.getPlayList()
    },
    //查看物料
    showMaterial(item) {
      this.materialModal = true;
      this.getMaterialDetail(item.materialId);
    },
    changePage (page, pageSize) {
      this.pageSize = pageSize;
      this.current = page;
      this.getMediaList()
    },
    getMediaList() {
      let params = {
        pageNum: this.current,
        pageSize: this.pageSize
      }
      for (let i in params) {
        params[i] ? '' : delete params[i]
      }
      api.getApi('/machine/getPrePlayMachineList', params).then(res => {
        if (res.data.code == 200) {
          this.total = res.data.data.total
          let result = res.data.data.list;
          this.mediaList = result.map((item, index) => {
            return {
              key: index,
              pointId: item.pointId,
              MAC: item.mac,
              deviceName: item.deviceName || '--',
              deviceCode: item.deviceCode || '--',
              TerminalType: item.version || '--',
              TerminalSystem: item.system || '--',
              province: item.province || '',
              city: item.city || '',
              area: item.area || '',
              companyName: item.companyName || '--',
              communityName: item.communityName || '--',
              mediaStatus: item.devStatus || '--',
              doorName: item.doorName || '--',
              devOnlineStatus: item.devOnlineStatus || '--',
              publishStatus: item.publishStatus,
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //获取播放列表
    getPlayList() {
      api
        .getApi("/machine/getPrePlayRecordList?pointId=" + this.pointId)
        .then((res) => {
          if (res.data.code == 200) {
            let arr = [];
            let result = res.data.data;
            arr = result.map((item, index) => {
              return {
                key: index,
                planId: item.planId,
                planName: item.planName,
                conditionText: item.conditionText,
                beginTime: timeFormat.toDateTime(item.beginTime),
                endTime: timeFormat.toDateTime(item.endTime),
                materialId: item.materialId,
              };
            });
            this.playList = arr;
            console.log(this.playList);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    onShowSizeChange(current, pageSize) {
      // console.log(current, pageSize);
      this.pageSize = pageSize;
      this.getMediaList();
    },
    //跳转详情
    goPlanDetail (row) {
      sessionStorage.setItem('planId', row.planId);
      this.$router.push('/channelAdPlanDetail')
    },
    //查看物料
    showMaterial (item) {
      console.log(item);
      this.materialModal = true;
      this.getMaterialDetail(item.materialId)
    }
  },
};
</script>

<style lang="scss" scoped>
.readyplay_list {
  position: absolute;
  right: 32px;
  top: 120px;
}

.readyplay_list span {
  font-size: 14px;
  vertical-align: middle;
  cursor: pointer;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.ant-col-8 .ant-input,
.ant-col-8 .ant-cascader-picker {
  width: 90%;
}

.img-mask img {
  width: 100%;
  height: 100%;
}

.img-mask video,
.video-box video {
  width: 100%;
}

.play-modal .radio-wrap {
  text-align: center;
  margin-bottom: 16px;
}

.page-wrap {
  float: unset;
  text-align: right;
}

.material-box {
  width: 264px;
  height: 500px;
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url("../../../../public/images/material.png") no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 4px 4px;
  position: relative;
}

.material-box .img-mask,
.material-box .video-mask {
  width: 222px;
  height: 160px;
  /*border: 1px solid #000;*/
  border-radius: 4px;
  cursor: pointer;
}

.material-box.half-screen-mask {
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url("../../../../public/images/half-material.png") no-repeat;
}

.material-box.full-screen-mask .img-mask {
  height: 340px;
}

.material-box.full-screen-mask {
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url("../../../../public/images/fullMaterial.png") no-repeat;
}

.material-box-wrap {
  display: flex;
  justify-content: space-around;
}
</style>
